<template lang="pug">
  #actions.center-panel.md-scrollbar.md-theme-default
    md-content.md-layout-row.md-gutter.md-elevation-1(md-theme="white")
      module-menu
      .md-flex(md-theme="white")
        md-table(md-theme="white")
          md-table-row(v-for="action in actions" v-bind:key="action.id" v-bind:class="($route.params.action_code && $route.params.action_code == action.code) ? 'action-row hovered' : 'action-row'")
            md-table-cell.load
              router-link.small.md-primary(v-bind:to="{ name: 'Action', params: {code: $route.params.code, action_code: action.code}, query: $route.query }")
                span.md-layout-row.md-gutter
                    span.md-flex.name {{action.name + ' (' + action.code + ')'}}
</template>

<script>
  import ModuleMenu from './menu.vue';

  export default {
      data() {
          return {
          }
      },
      components: {
        ModuleMenu
      },
      computed: {
        actions() {
          return this.$store.state.module.actions;
        }
      },
      created() {
        this.getModuleActions();
      },
      methods: {
        getModuleActions() {
            this.$store.dispatch('module/getModuleActions', this.$route.params.code);
        }
      }
  }
</script>
  <style scoped lang="sass">
  .action-row.hovered
    .md-table-cell
      background-color: var(--md-theme-default-highlight-on-background, rgba(0, 0, 0, 0.08));
  </style>



// WEBPACK FOOTER //
// Actions.vue?e268961c